import React, { useEffect, useState } from "react";
import { askDataKeyValue2 } from "../../../utils/actions/firebase/firebaseActions";

const CrudRegAssignmentsTableRow = ({
	el,
	openModal1,
	goSeeDetail,
	company,
}) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [activities, setActivities] = useState([]);
	const [questions, setQuestions] = useState(null);
	const [responses, setResponses] = useState(0);

	const askActivities = async () => {
		setLoading(true);
		const nameCollection = "activitiesRegister-" + company;
		const key = "processNumber";
		const value = el.processNumber;
		const key2 = "stage";
		const value2 = el.stage;
		const response = await askDataKeyValue2(
			nameCollection,
			key,
			value,
			key2,
			value2
		);
		if (response.statusResponse === true) {
			setActivities(response.data);
			setQuestions(response.data.length);
			let answers = 0;
			response.data.map((line) => {
				if (line.response !== "") {
					answers = answers + 1;
				}
			});
			setResponses(answers);
			setLoading(false);
		} else {
			setActivities([]);
			setError(response.error);
			setLoading(false);
		}
	};

	useEffect(() => {
		askActivities();
	}, []);

	const buttonAction = (el) => {
		localStorage.setItem("assignment", JSON.stringify(el));
		goSeeDetail();
	};

	return (
		<tr className="fila-tabla-cuenstasxx">
			<td className="col-tabla-regtarea1">{el.date}</td>
			<td className="col-tabla-regtarea2">{el.processNumber}</td>
			<td className="col-tabla-regprocesos1">{el.process}</td>
			<td className="col-tabla-regprocesos1">{el.stage}</td>
			<td className="col-tabla-regtarea1">
				{responses === questions ? (
					<div className="responseColorFull">
						{Math.round((responses * 100) / questions)}%
					</div>
				) : (
					<div className="responseColorEmpty">
						{Math.round((responses * 100) / questions)}%
					</div>
				)}
			</td>
			<td className="col-tabla-regprocesos2">
				<button
					onClick={() => buttonAction(el)}
					className="btn-ver-regprocesos"
				>
					Ver
				</button>
			</td>
		</tr>
	);
};

export default CrudRegAssignmentsTableRow;
